<template lang="pug">
v-container(
  fluid
  px-0
  fill-height
  class=" tw-items-start tw-content-start tw-overflow-x-hidden tw-bg-blueGray-lighten-5 tw-h-full "
)
  kubiqa-website-themes-theme-e-components-shared-top-navigation(class="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-z-10")
  div(class="tw-h-20") &nbsp;
  v-row(no-gutters align="center" justify="space-around" class=" tw-bg-blueGray-lighten-4 tw-h-26 tw-py-4")
    v-col(cols="12")
      div(class="tw-grid")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1 ")
          kubiqa-website-shared-widget-editor(
            page="about"
            placement="header"
            @content="(content) => (content != null ? (defaultHeader = false) : (defaultHeader = true))"
          )
        div(v-if="defaultHeader" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
          div(class="tw-h-full  tw-items-center tw-flex")
            v-row(no-gutters justify="center")
              v-col(cols="9")
                span(class="tw-font-bold tw-text-white tw-text-2xl") About
  v-row(
    no-gutters
    align="start"
    justify="center"
    class=" tw-bg-blueGray-lighten-5 tw-z-0 flex-grow-1 d-fex flex-row tw-flex-grow tw-h-full tw-pt-8"
  )
    v-col(cols="12" class="fill-height")
      div(class="tw-grid fill-height")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1 ")
          kubiqa-website-shared-widget-editor(
            page="about"
            placement="description"
            @content="(content) => (content != null ? (defaultDescription = false) : (defaultDescription = true))"
            class=" fill-height"
          )
        div(v-if="defaultDescription" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12 tw-align-middle")
          v-row(align="start" justify="center")
            v-col(cols="6" class="")
              p
                span(class="tw-font-bold tw-text-2xl") Tower Real Estate
              p
                span {{ this.$faker().lorem.paragraphs(2) }}
              p
                span {{ this.$faker().lorem.paragraphs(2) }}
              p
                span {{ this.$faker().lorem.paragraphs(2) }}
            v-col(cols="4" class="")
              v-img(
                :src="sampleWebsiteImage('houseExterior', 600, 300)"
                aspect-ratio="2"
                contain
                class="tw-rounded-md tw-border-4 tw-shadow-md tw-border-white"
              )

  v-row(class="tw-pt-24 ")
    v-col

  kubiqa-website-themes-theme-e-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      defaultHeader: true,
      defaultDescription: true,
    };
  },
};
</script>
<style lang="stylus">
.filters-active
    background-color: #ffffff


:focus
    outline: 0 !important
</style>
